import React from 'react';
import { Link } from 'react-router-dom';

const Fitness = () => {
  const categories = [
    {
      id: 'protein',
      title: 'אבקות חלבון',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/8smsy2g0_4.png',
      path: '/fitness/protein'
    },
    {
      id: 'supplements',
      title: 'תוספים',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/satdw9r3_1.png',
      path: '/fitness/supplements'
    },
    {
      id: 'energy',
      title: 'חטיפי אנרגיה',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/wr5vxjk3_cf2c16_b4aa4432794c4015b8dfa3434bc6de13~mv2.avif',
      path: '/fitness/energy'
    },
    {
      id: 'hot-deals',
      title: 'מבצעים חמים',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/bbwmzl97_2.png',
      path: '/fitness/deals'
    }
  ];
  
  return (
    <div className="container py-16" data-testid="fitness-page">
      {/* Title */}
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="fitness-title">
          המוצרים שלנו
        </h1>
      </div>
      
      {/* Categories Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto" data-testid="fitness-categories">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={category.path}
            className="group block"
            data-testid={`fitness-category-${category.id}`}
          >
            <div className={`relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 bg-white h-full flex flex-col ${
              category.id === 'hot-deals' ? 'ring-4 ring-[#D97706] ring-offset-2' : ''
            }`}>
              {category.id === 'hot-deals' && (
                <div className="absolute top-0 left-0 right-0 bg-[#D97706] text-white text-center py-1 z-10">
                  <span className="font-bold text-sm">🔥 מבצע!</span>
                </div>
              )}
              <div className="flex-1 flex items-center justify-center p-4 bg-white" style={{ minHeight: '180px' }}>
                <img
                  src={category.image}
                  alt={category.title}
                  className="max-w-full max-h-40 object-contain group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="bg-[#2C3E2D] py-3 text-center">
                <p className="text-xs text-stone-300 mb-1">לפרטים נוספים</p>
                <h2 className="text-base md:text-lg font-bold text-white" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {category.title}
                </h2>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Fitness;
